<template lang="html">
  <v-btn
    :color="color"
    class="btn font-weight-light mx-1"
    @click="$emit('click', $event)">
    <slot>
      <span class='default'>{{ text }}</span>
    </slot>
  </v-btn>
</template>

<script>
export default {
  props: {
    color: {
      required: false,
      default: 'primary',
      type: String
    },
    text: {
      required: false,
      default: 'Click Me!',
      type: String
    }
  }
}
</script>

<style lang="css" scoped>
</style>
